<!-- 待办工单 -->
<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('工单编号')">
              <a-input :placeholder="$t('请输入工单编号')" v-model="queryParam.ticketsNum"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('工单紧急程度')">
              <j-dict-select-tag
                v-model="queryParam.ticketsEmergency"
                :placeholder="$t('请选择工单紧急程度')"
                dictCode="ticketsEmergency"
                style="width: 100%"
              />
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('工单类型')">
              <a-select v-model="queryParam.ticketsType" :placeholder="$t('请选择工单类型')">
                <a-select-option :value="0">{{ $t('换表') }}</a-select-option>
                <a-select-option :value="2">{{ $t('故障报修') }}</a-select-option>
                <a-select-option :value="11">{{ $t('水厂报修') }}</a-select-option>
                <a-select-option :value="3">{{ $t('报停') }}</a-select-option>
                <a-select-option :value="4">{{ $t('复接') }}</a-select-option>
                <a-select-option :value="7">{{ $t('销户') }}</a-select-option>
                <a-select-option :value="8">{{ $t('用水性质变更') }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <!-- <a-col :xl="6" :lg="7" :md="8" :sm="24" v-if="toggleSearchStatus">
            <a-form-item label="处理人员">
              <a-select v-model="queryParam.approverName" placeholder="请选择处理人员">
                <a-select-option v-for="(item,index) in pList" :value="item.username" :key="index">{{item.username}}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col> -->
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left; overflow: hidden" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? $t('收起') : $t('展开') }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'" />
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <!-- <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button> -->
      <!-- <a-button type="primary" icon="download" @click="handleExportXls('tickets')">导出</a-button> -->
      <!-- <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
        <a-button type="primary" icon="import">导入</a-button>
      </a-upload> -->
      <!-- 高级查询区域 -->
      <!-- <j-super-query :fieldList="superFieldList" ref="superQueryModal" @handleSuperQuery="handleSuperQuery"></j-super-query>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>删除</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> 批量操作 <a-icon type="down" /></a-button>
      </a-dropdown> -->
    </div>

    <!-- table区域-begin -->
    <div class="table-fixed">
      <!-- <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div> -->

      <a-table
        ref="table"
        size="middle"
        :scroll="{ x: true }"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        class="j-table-force-nowrap"
        :components="drag(columns)"
        @change="handleTableChange"
      >
        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text, record">
          <span v-if="!text" style="font-size: 12px; font-style: italic">{{ $t('无图片') }}</span>
          <img
            v-else
            :src="getImgView(text)"
            :preview="record.id"
            height="25px"
            alt=""
            style="max-width: 80px; font-size: 12px; font-style: italic"
          />
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px; font-style: italic">{{ $t('无文件') }}</span>
          <a-button v-else :ghost="true" type="primary" icon="download" size="small" @click="downloadFile(text)">
            {{ $t('下载') }}
          </a-button>
        </template>
        <template slot="ticketsState" slot-scope="text, record">
          <!-- 换表 -->
          <span v-if="record.ticketsType == 0">
            {{ meterTypeList[text] }}
          </span>
          <!-- 工程报装 -->
          <span v-if="record.ticketsType == 1">
            {{ engineeringList[text] }}
          </span>
          <!-- 故障报修 -->
          <span v-if="record.ticketsType == 2 || record.ticketsType == 11">
            {{ repairList[text] }}
          </span>

          <!-- 报停 -->
          <span v-if="record.ticketsType == 3">
            {{ meterTypeList2[text] }}
          </span>
          <!-- 复接 -->
          <span v-if="record.ticketsType == 4">
            {{ meterTypeList2[text] }}
          </span>
          <!-- 销户 -->
          <span v-if="record.ticketsType == 7">
            {{ meterTypeList2[text] }}
          </span>
          <!-- 用水性质便跟 -->
          <span v-if="record.ticketsType == 8">
            {{ meterTypeList2[text] }}
          </span>
        </template>
        <template slot="createBy" slot-scope="text, record">
          <span>{{ text ? text : $t('微信端游客') }}</span>
        </template>
        <span slot="ticketsNum" slot-scope="text, record">
          <span>{{ text }}&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span @click.stop="copySampleNoLink(record.ticketsNum)" class="copySampleNo"><a-icon type="copy" /></span>
        </span>
        <span slot="ticketsEmergency" slot-scope="text, record">
          <a-tag color="red" v-if="text == 0">{{ filterDictTextByCache('ticketsEmergency', text) }}</a-tag>
          <a-tag color="orange" v-else-if="text == 1">{{ filterDictTextByCache('ticketsEmergency', text) }}</a-tag>
          <a-tag color="yellow" v-else-if="text == 2">{{ filterDictTextByCache('ticketsEmergency', text) }}</a-tag>
          <a-tag color="blue" v-else-if="text == 3">{{ filterDictTextByCache('ticketsEmergency', text) }}</a-tag>
        </span>

        <span slot="action" slot-scope="text, record">
          <!-- <a @click="handleEdit(record)" v-if="record.ticketsState == 0">编辑</a>
          <a-divider type="vertical" v-if="record.ticketsState == 0" />
          <a-popconfirm title="确定启动流程吗?" @confirm="() => handleStart(record)" v-if="record.ticketsState == 0">
            <a>启动流程</a>
          </a-popconfirm>
          <a-divider type="vertical" v-if="record.ticketsState == 0" /> -->
          <template v-if="record.ticketsState != 0">
            <!-- 换表操作 -->
            <template v-if="record.ticketsType == 0 && record.ticketsState > 0">
              <!-- <template v-if="record.ticketsState > 0 && record.ticketsState < 3 ">
                <a @click="handleEdit(record)">编辑</a>
                <a-divider type="vertical" />
              </template> -->
              <!-- <template v-if="record.ticketsState == 1">
                <a @click="() => showTakeOrderModal(record,'接单')">接单</a>
              </template> -->
              <a @click="handleWorkOrder(record)" v-if="record.ticketsState == 1"> {{ $t('处理') }}</a>
              <a @click="handleNewAudit(record)" v-else-if="record.ticketsState == 2">{{ $t('审核工单') }}</a>
              <!-- <a @click="handleArchive(record)" v-else-if="record.ticketsState == 4">归档</a> -->
              <a @click="showTakeOrderModal(record, '归档')" v-else-if="record.ticketsState == 3">{{ $t('归档') }}</a>
              <a-divider type="vertical" v-if="record.ticketsState > 0 && record.ticketsState < 6" />
            </template>

            <!-- 工程报装 -->
            <template v-else-if="record.ticketsType == 1 && record.ticketsState > 0">
              <!-- <template v-if="record.ticketsState == 1">
                <a @click="handleEdit(record)">编辑</a>
                <a-divider type="vertical" />
              </template> -->
              <a @click="handleFlow(record)">{{ $t('处理') }}</a>
              <a-divider type="vertical" v-if="record.ticketsState > 0 && record.ticketsState < 11" />
            </template>

            <!-- 故障报修 -->
            <template v-else-if="(record.ticketsType == 2 || record.ticketsType == 11 ) && record.ticketsState > 0">
              <!-- <template v-if="record.ticketsState > 0 && record.ticketsState < 3 ">
                <a @click="handleEdit(record)">编辑</a>
                <a-divider type="vertical" />
              </template> -->
              <!-- <template v-if="record.ticketsState == 1">
                <a @click="() => showTakeOrderModal(record,'接单')">接单</a>
                <a-divider type="vertical" />
              </template> -->
              <template v-if="record.ticketsState == 1">
                <a @click="handleRepair(record)">{{ $t('处理') }}</a>
                <a-divider type="vertical" />
              </template>
              <template v-if="record.ticketsState == 2">
                <a @click="handleRepair(record)">{{ $t('审核工单') }}</a>
                <a-divider type="vertical" />
              </template>
              <template v-if="record.ticketsState == 3">
                <a @click="showTakeOrderModal(record, '归档')">{{ $t('归档') }}</a>
                <a-divider type="vertical" />
              </template>
              <!-- <a-divider type="vertical" v-if="record.ticketsState > 0 && record.ticketsState < 4" /> -->
            </template>

            <!-- 报停 -->
            <template v-else-if="record.ticketsType == 3 && record.ticketsState > 0">
              <template v-if="record.ticketsState == 1">
                <a @click="handleTearDownAndInstall(record)">{{ $t('处理') }}</a>
                <a-divider type="vertical" />
              </template>

              <template v-if="record.ticketsState == 2">
                <a @click="handleTearDownAndInstall(record)">{{ $t('审核工单') }}</a>
                <a-divider type="vertical" />
              </template>

              <template v-if="record.ticketsState == 3">
                <a @click="showTakeOrderModal(record, '归档')">{{ $t('归档') }}</a>
                <a-divider type="vertical" />
              </template>

              <!-- <a-divider type="vertical" v-if="record.ticketsState > 0 && record.ticketsState < 4" /> -->
            </template>

            <!-- 复接 -->
            <template v-else-if="record.ticketsType == 4 && record.ticketsState > 0">
              <template v-if="record.ticketsState == 1">
                <a @click="handleTearDownAndInstall(record)">{{ $t('处理') }}</a>
                <a-divider type="vertical" />
              </template>

              <template v-if="record.ticketsState == 2">
                <a @click="handleTearDownAndInstall(record)">{{ $t('审核工单') }}</a>
                <a-divider type="vertical" />
              </template>

              <template v-if="record.ticketsState == 3">
                <a @click="showTakeOrderModal(record, '归档')">{{ $t('归档') }}</a>
                <a-divider type="vertical" />
              </template>

              <!-- <a-divider type="vertical" v-if="record.ticketsState > 0 && record.ticketsState < 4" /> -->
            </template>

            <!-- 销户 -->
            <template v-else-if="record.ticketsType == 7 && record.ticketsState > 0">
              <template v-if="record.ticketsState == 1">
                <a @click="handleTearDownAndInstall(record)">{{ $t('处理') }}</a>
                <a-divider type="vertical" />
              </template>

              <template v-if="record.ticketsState == 2">
                <a @click="handleTearDownAndInstall(record)">{{ $t('审核工单') }}</a>
                <a-divider type="vertical" />
              </template>

              <template v-if="record.ticketsState == 3">
                <a @click="showTakeOrderModal(record, '归档')">{{ $t('归档') }}</a>
                <a-divider type="vertical" />
              </template>

              <!-- <a-divider type="vertical" v-if="record.ticketsState > 0 && record.ticketsState < 4" /> -->
            </template>

            <!-- 用水性质变更 -->
            <template v-else-if="record.ticketsType == 8 && record.ticketsState > 0">
              <template v-if="record.ticketsState == 1">
                <a @click="handleTearDownAndInstall(record)">{{ $t('处理') }}</a>
                <a-divider type="vertical" />
              </template>

              <template v-if="record.ticketsState == 2">
                <a @click="handleTearDownAndInstall(record)">{{ $t('审核工单') }}</a>
                <a-divider type="vertical" />
              </template>

              <template v-if="record.ticketsState == 3">
                <a @click="showTakeOrderModal(record, '归档')">{{ $t('归档') }}</a>
                <a-divider type="vertical" />
              </template>

              <!-- <a-divider type="vertical" v-if="record.ticketsState > 0 && record.ticketsState < 4" /> -->
            </template>

            <a @click="handleTransfer(record)">{{ $t('转办') }}</a>
            <a-divider type="vertical" />
            <a @click="handleNotClaim(record)">{{ $t('取消签收') }}</a>
            <a-divider type="vertical" />
          </template>

          <a-dropdown>
            <a class="ant-dropdown-link">{{ $t('更多') }} <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleDetail(record)">{{ $t('详情') }}</a>
              </a-menu-item>
              <a-menu-item>
                <TaskActHistoricDetailBtn
                  class="myLink"
                  :data-id="record.id"
                  v-if="record.ticketsState != 0"
                ></TaskActHistoricDetailBtn>
              </a-menu-item>
              <a-menu-item>
                <a @click="handleReject(record)">{{ $t('驳回') }}</a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
    </div>

    <workModal ref="modalForm" @ok="loadData"></workModal>
    <detailModal ref="detailForm" @ok="loadData"></detailModal>
    <auditModal ref="auditForm" @ok="loadData"></auditModal>
    <newMeterModal ref="newMeterForm" @ok="loadData"></newMeterModal>
    <!-- 工程报装 -->
    <Examine ref="ExamineForm" @ok="loadData"></Examine>
    <SurveyInformation ref="SurveyInformationForm" @ok="loadData"></SurveyInformation>
    <Drawing ref="DrawingForm" @ok="loadData"></Drawing>
    <LeaderApproval ref="LeaderApprovalForm" @ok="loadData"></LeaderApproval>
    <FinancialConfirmation ref="FinancialConfirmationForm" @ok="loadData"></FinancialConfirmation>
    <EnterConstruction ref="EnterConstructionForm" @ok="loadData"></EnterConstruction>
    <EngineeringAcceptance ref="EngineeringAcceptanceForm" @ok="loadData"></EngineeringAcceptance>
    <putOnRecord ref="putOnRecordForm" @ok="loadData"></putOnRecord>
    <EngineeringInstallationDetail
      ref="EngineeringInstallationDetailForm"
      @ok="loadData"
    ></EngineeringInstallationDetail>
    <!-- 故障报修 -->
    <repairOrdersModal ref="repairOrdersForm" @ok="loadData" />
    <!-- 接单 -->
    <RepairDetailModal ref="RepairDetailForm" @ok="loadData" />
    <!-- 详情 -->
    <repairPlaceModal ref="RepairPlaceForm" @ok="loadData" />
    <!-- 归档 -->
    <repairRegisterModal ref="RepairRegisterForm" @ok="loadData" />
    <!-- 登记审批 -->
    <!-- 报停 复接 销户 ：处理审核页面 -->
    <TearDownAndInstallModal ref="tearDownAndInstallModalForm" @ok="loadData" />
    <TearDownAndInstallDetail ref="tearDownAndInstallDetailForm" @ok="loadData" />
    <j-modal
      :title="title"
      :width="800"
      :visible="visible"
      :confirmLoading="confirmLoading"
      :maskClosable="false"
      @ok="handleOk"
      @cancel="handleCancel"
      :okText="$t('确定')"
      :cancelText="$t('关闭')"
    >
      <a-spin :spinning="confirmLoading">
        <j-form-container>
          <a-form-model ref="form" :model="model" :rules="validatorRules" slot="detail" :colon="false">
            <a-form-model-item :label="$t('选择人员')" prop="assignee">
              <j-select-user-by-dep v-model="model.assignee" :multi="false"></j-select-user-by-dep>
            </a-form-model-item>

            <a-form-model-item :label="$t('备注')" prop="remark">
              <a-textarea v-model="model.remark" :placeholder="$t('请输入备注')" :rows="4" />
            </a-form-model-item>
          </a-form-model>
        </j-form-container>
      </a-spin>
    </j-modal>
    <!-- 接单弹窗组件 -->
    <take-order-modal ref="takeOrderModal" @success="loadData" />
  </a-card>
</template>

<script>
import JInput from '@/components/jeecg/JInput'
import '@/assets/less/TableExpand.less'
import { mixinDevice } from '@/utils/mixin'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import TableDragResize from '@/mixins/TableDragResize'
import { httpAction, getAction, postAction } from '@/api/manage'
import { filterDictTextByMany, filterDictTextByCache } from '@/components/dict/JDictSelectUtil'
import workModal from './modules/workModal'
import detailModal from './modules/detailModal.vue'
import auditModal from './modules/auditModal.vue'
import newMeterModal from './modules/newMeterModal.vue'
import TaskActHistoricDetailBtn from './flowable/TaskActHistoricDetailBtn.vue'
// ------------------------------工程报装--------------------------------------
import Examine from '@/views/engineeringInstallation/constructionManagement/modules/examine/ConstructionDetailModal' //工程部审核、审核
import SurveyInformation from '@/views/engineeringInstallation/constructionManagement/modules/surveyInformation/ConstructionDetailModal' //录入勘测信息
import Drawing from '@/views/engineeringInstallation/constructionManagement/modules/drawing/ConstructionDetailModal' //录入图纸和预算
import LeaderApproval from '@/views/engineeringInstallation/constructionManagement/modules/leaderApproval/ConstructionDetailModal' //审批图纸和预算、审批合同
import FinancialConfirmation from '@/views/engineeringInstallation/constructionManagement/modules/financialConfirmation/ConstructionDetailModal' //财务确认
import EnterConstruction from '@/views/engineeringInstallation/constructionManagement/modules/enterConstruction/ConstructionDetailModal' //录入施工文件
import EngineeringAcceptance from '@/views/engineeringInstallation/constructionManagement/modules/engineeringAcceptance/ConstructionDetailModal' //工程验收
import putOnRecord from './modules/putOnRecord' //建档
import EngineeringInstallationDetail from './modules/EngineeringInstallationDetail' //全部流程详情
//  ------------------------------故障报修--------------------------------------
import repairOrdersModal from './modules/repairOrdersModal' //故障报修审核
import RepairDetailModal from './modules/repairDetailModal' //故障报修详情
import repairPlaceModal from './modules/repairPlaceModal' //故障报修归档
import repairRegisterModal from './modules/repairRegisterModal' //故障报修登记审批
import JSelectUserByDep from '@/components/jeecgbiz/JSelectUserByDep'
import TakeOrderModal from './modules/takeOrder.vue'
import TearDownAndInstallModal from './modules/TearDownAndInstallModal.vue'
import TearDownAndInstallDetail from './modules/TearDownAndInstallDetail.vue'
export default {
  name: 'workList',
  mixins: [JeecgListMixin, mixinDevice, TableDragResize],
  components: {
    workModal,
    detailModal,
    auditModal,
    newMeterModal,
    TaskActHistoricDetailBtn,
    Examine,
    SurveyInformation,
    Drawing,
    LeaderApproval,
    FinancialConfirmation,
    EnterConstruction,
    EngineeringAcceptance,
    putOnRecord,
    EngineeringInstallationDetail,
    repairOrdersModal,
    RepairDetailModal,
    repairPlaceModal,
    JInput,
    repairRegisterModal,
    JSelectUserByDep,
    TakeOrderModal,
    TearDownAndInstallModal,
    TearDownAndInstallDetail,
  },
  data() {
    return {
      description: '工单管理页面',
      filterDictTextByCache: filterDictTextByCache,
      url: {
        list: '/jeecg-engineering/ticket/tickets/list',
        delete: '/jeecg-engineering/ticket/tickets/delete',
        deleteBatch: '/jeecg-engineering/ticket/tickets/deleteBatch',
        exportXlsUrl: '/jeecg-engineering/ticket/tickets/exportXls',
        importExcelUrl: 'jeecg-engineering/ticket/tickets/importExcel',
        start: '/jeecg-engineering/ticket/tickets/startProcess/tickets',
        pass: '/jeecg-engineering/flowable/task/completeByDateId',
        userList: '/sys/user/list',
        delegate: '/jeecg-engineering/flowable/task/delegate',
        assign: '/jeecg-engineering/flowable/task/assign',
        reject: '/jeecg-engineering/flowable/task/taskRejectByDataId',
        notClaim: '/jeecg-engineering/flowable/task/unClaim',
      },
      dictOptions: {},
      superFieldList: [],
      queryParam: {
        workState: 1,
        belongModule: 'tickets',
      },
      clickRow: {},
      title: '',
      visible: false,
      model: {},
      confirmLoading: false,
    }
  },
  computed: {
    importExcelUrl: function () {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
    },
    // 表头
    columns() {
      return [
        {
          title: '#',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: (t, r, index) => {
            return parseInt(index) + 1
          },
        },
        {
          title: this.$t('工单编号'),
          align: 'center',
          dataIndex: 'ticketsNum',
          scopedSlots: { customRender: 'ticketsNum' },
          width: 200,
          ellipsis: true,
        },
        {
          title: this.$t('工单类型'),
          align: 'center',
          dataIndex: 'ticketsType',
          customRender: (text) => {
            return filterDictTextByCache('ticketsType', text)
          },
          width: 150,
          ellipsis: true,
        },
        {
          title: this.$t('工单紧急程度'),
          align: 'center',
          dataIndex: 'ticketsEmergency',
          // customRender: function (text) {
          //   return filterDictTextByCache('ticketsEmergency', text)
          // },
          scopedSlots: { customRender: 'ticketsEmergency' },
          width: 150,
          ellipsis: true,
        },
        {
          title: this.$t('工单状态'),
          dataIndex: 'ticketsState',
          align: 'center',
          width: 150,
          ellipsis: true,
          scopedSlots: { customRender: 'ticketsState' },
        },
        {
          title: this.$t('当前节点处理人'),
          align: 'center',
          dataIndex: 'approverName',
          customRender: (t, r, index) => {
            if (t) {
              return t
            } else {
              return '/'
            }
          },
          width: 200,
          ellipsis: true,
        },
        // {
        //   title:'工单截止时间',
        //   align:"center",
        //   dataIndex: 'ticketsDeadline'
        // },
        // {
        //   title:'工单位置',
        //   align:"center",
        //   dataIndex: 'ticketsLocation'
        // },
        // {
        //   title:'工单事务分类',
        //   align:"center",
        //   dataIndex: 'ticketsTransaction'
        // },
        {
          title: this.$t('工单联系人'),
          align: 'center',
          dataIndex: 'ticketsContact',
          width: 150,
          ellipsis: true,
        },
        {
          title: this.$t('联系电话'),
          align: 'center',
          dataIndex: 'ticketsContactPhone',
          width: 150,
          ellipsis: true,
        },
        {
          title: this.$t('申请人'),
          align: 'center',
          dataIndex: 'createBy',
          width: 150,
          ellipsis: true,
          scopedSlots: { customRender: 'createBy' },
        },
        {
          title: this.$t('申请时间'),
          align: 'center',
          dataIndex: 'createTime',
          width: 150,
          ellipsis: true,
        },
        {
          title: this.$t('更新时间'),
          align: 'center',
          dataIndex: 'updateTime',
          width: 150,
          ellipsis: true,
        },
        {
          title: this.$t('来源'),
          align: 'center',
          dataIndex: 'sourceType',
          customRender: (text) => {
            if(text == 1){
              return this.$t('小程序')
            }else if(text == 2){
              return this.$t('公众号')
            }else{
              return 'PC'
            }
          },
          width: 150,
          ellipsis: true,
        },
        {
          title: this.$t('操作'),
          dataIndex: 'action',
          align: 'center',
          fixed: 'right',
          width: 280,
          scopedSlots: { customRender: 'action' },
        },
      ]
    },
    // 工单状态选项值映射
    meterTypeList() {
      return [this.$t('新建工单'), this.$t('现场处理'), this.$t('大厅审核'), this.$t('归档'), this.$t('已结束')]
    },
    meterTypeList2() {
      return [this.$t('新建工单'), this.$t('现场处理'), this.$t('审核'), this.$t('归档'), this.$t('已结束')]
    },
    engineeringList() {
      return [
        this.$t('未开启'),
        this.$t('报装申请'),
        this.$t('报装受理'),
        this.$t('报装勘察设计'),
        this.$t('报装预算'),
        this.$t('报装审批'),
        this.$t('报装收费'),
        this.$t('报装施工'),
        this.$t('报装验收'),
        this.$t('报装建档'),
      ]
    },
    repairList() {
      return [this.$t('新建工单'), this.$t('现场处理'), this.$t('大厅审核'), this.$t('归档'), this.$t('已结束')]
    },
    validatorRules() {
      return {
        assignee: [{ required: true, message: this.$t('请选择人员') }],
      }
    },
  },
  created() {
    this.getSuperFieldList()
    this.getPersonnelList()
    // 只在首次加载时设置参数
    if (this.$route.query && this.$route.query.ticketsNum) {
      this.queryParam.ticketsNum = this.$route.query.ticketsNum
      // 确保其他查询条件不变
      this.queryParam.workState = 1
      this.queryParam.belongModule = 'tickets'

      // 定义一个回调函数，在数据加载完成后执行
      this.loadData(undefined, () => {
        this.searchQuery()
        if (this.dataSource?.length > 0) {
          const firstRow = this.dataSource[0]
          this.checkRowStatus(firstRow)
        }
      })
    }
  },
  methods: {
    getPersonnelList() {
      getAction(this.url.userList, { status: 1, pageSize: 999 }).then(res => {
        if (res.success) {
          this.pList = res.result.records
        }
      })
    },
    initDictConfig() {},
    getSuperFieldList() {
      let fieldList = []
      fieldList.push({ type: 'int', value: 'ticketsType', text: '工单类型,0:换表' })
      fieldList.push({ type: 'string', value: 'ticketsForeignId', text: '工单外键id' })
      fieldList.push({ type: 'string', value: 'ticketsProcessKey', text: '工单流程key' })
      fieldList.push({ type: 'string', value: 'ticketsNum', text: '工单编号' })
      fieldList.push({ type: 'string', value: 'ticketsLocation', text: '工单位置' })
      fieldList.push({ type: 'string', value: 'ticketsContact', text: '工单联系人' })
      fieldList.push({ type: 'string', value: 'ticketsContactPhone', text: '联系电话' })
      fieldList.push({ type: 'int', value: 'ticketsEmergency', text: '工单紧急程度' })
      fieldList.push({ type: 'int', value: 'ticketsTransaction', text: '工单事务分类' })
      fieldList.push({ type: 'date', value: 'ticketsDeadline', text: '工单截至时间' })
      fieldList.push({ type: 'string', value: 'remark', text: '备注信息' })
      this.superFieldList = fieldList
    },
    searchReset() {
      this.queryParam = {
        workState: 1,
        belongModule: 'tickets',
      }
      this.loadData()
    },
    handleEdit(row) {
      this.$nextTick(() => {
        this.$refs.modalForm.edit(row, 'edit')
      })
    },
    handleNotClaim(row) {
      this.confirmLoading = true
      postAction(this.url.notClaim, { dataId: row.id })
        .then(res => {
          if (res.success) {
            this.$message.success(this.$t('取消签收成功'))
          } else {
            this.$message.error(res.message)
          }
          this.loadData()
        })
        .finally(() => {
          this.confirmLoading = false
        })
    },
    handleReject(row) {
      this.$refs.takeOrderModal.showModal(row, this.url, '驳回')
    },
    // 详情
    handleDetail(row) {
      this.$nextTick(() => {
        if (row.ticketsType == 0) {
          // 换表
          this.$refs.detailForm.init(row)
        } else if (row.ticketsType == 1) {
          this.$refs.EngineeringInstallationDetailForm.init(row, true)
        } else if (row.ticketsType == 2 || row.ticketsType == 11) {
          // 报修
          this.$refs.RepairDetailForm.init(row, this.$t('详情'))
        } else if (row.ticketsType == 3 || row.ticketsType == 4 || row.ticketsType == 7 || row.ticketsType == 8) {
          // 复接 报停 销户
          this.$refs.tearDownAndInstallDetailForm.init(row, this.$t('详情'))
        }
      })
    },
    // 开启
    handleStart(row) {
      this.loading = true
      postAction(this.url.start, { dataId: row.id, flowableKey: row.ticketsProcessKey }).then(res => {
        if (res.success) {
          this.$message.success(this.$t('开启成功'))
          this.loading = false
          this.loadData()
        } else {
          this.$message.error(res.message)
          this.loading = false
        }
      })
    },
    // 审核旧表
    handleOldAudit(row, type) {
      this.$nextTick(() => {
        this.$refs.auditForm.init(row, 'old')
        if (type) {
          this.$refs.auditForm.title = this.$t('处理')
        }
      })
    },
    // 绑定新表
    handleNewMeter(row) {
      this.$nextTick(() => {
        this.$refs.newMeterForm.init(row)
      })
    },
    // 安装
    handleInstall(row) {
      this.loading = true
      let params = {
        dataId: row.id,
        values: {
          dataId: row.id,
        },
        comment: '',
      }
      postAction(this.url.pass, params).then(res => {
        if (res.success) {
          this.$message.success(this.$t('安装成功'))
          this.loadData()
        } else {
          this.$message.error(res.message)
        }
      })
    },
    // 审核新表
    handleNewAudit(row) {
      this.$nextTick(() => {
        this.$refs.auditForm.init(row, this.$t('审核'))
      })
    },
    // 归档
    handleArchive(record) {
      let that = this
      this.loading = true
      let httpurl = this.url.pass
      let params = {
        dataId: record.id,
        values: {
          dataId: record.id,
        },
        comment: '',
      }
      postAction(httpurl, params)
        .then(res => {
          if (res.success) {
            that.$message.success(this.$t('操作成功'))
          } else {
            that.$message.warning(res.message)
          }
        })
        .finally(() => {
          that.loading = false
          that.loadData()
        })
    },
    // 换表处理
    handleWorkOrder(row) {
      this.$nextTick(() => {
        this.$refs.auditForm.init(row, this.$t('处理'))
      })
    },
    // 工程报装-处理
    handleFlow(row) {
      this.$nextTick(() => {
        if (row.ticketsState == 1) {
          //从受理驳回后重新处理
          this.$refs.ExamineForm.edit(row, true)
        } else if (row.ticketsState == 2) {
          //受理
          this.$refs.ExamineForm.edit(row, true)
        } else if (row.ticketsState == 3) {
          //勘察设计
          this.$refs.SurveyInformationForm.edit(row, true)
        } else if (row.ticketsState == 4) {
          //预算
          this.$refs.DrawingForm.edit(row, true)
        } else if (row.ticketsState == 5) {
          //审批
          this.$refs.LeaderApprovalForm.edit(row, true)
        } else if (row.ticketsState == 6) {
          //收费
          this.$refs.FinancialConfirmationForm.edit(row, true)
        } else if (row.ticketsState == 7) {
          //施工
          this.$refs.EnterConstructionForm.edit(row, true)
        } else if (row.ticketsState == 8) {
          //验收
          this.$refs.EngineeringAcceptanceForm.edit(row, true)
        } else if (row.ticketsState == 9) {
          //建档
          this.$refs.putOnRecordForm.init(row, true)
        }
      })
    },
    // 报停 复接 ：处理 审核页面
    handleTearDownAndInstall(row) {
      this.$nextTick(() => {
        // if(row.ticketsState == 1){
        //   this.$refs.RepairRegisterForm.init(row);//登记审批
        // }else
        if (row.ticketsState == 1) {
          this.$refs.tearDownAndInstallModalForm.init(row, this.$t('处理')) //处理
        } else if (row.ticketsState == 2) {
          this.$refs.tearDownAndInstallModalForm.init(row, this.$t('审核'))
        } else if (row.ticketsState == 3) {
          // 归档
          let httpurl = this.url.pass
          let params = {
            dataId: record.id,
            values: {
              dataId: record.id,
            },
            comment: '',
          }
          postAction(httpurl, params).then(res => {
            if (res.success) {
              that.$message.success(this.$t('操作成功'))
            } else {
              that.$message.warning(res.message)
            }
          })
        }
      })
    },
    // 故障报修-处理
    handleRepair(row) {
      this.$nextTick(() => {
        // if(row.ticketsState == 1){
        //   this.$refs.RepairRegisterForm.init(row);//登记审批
        // }else
        if (row.ticketsState == 1) {
          this.$refs.repairOrdersForm.init(row, this.$t('处理')) //处理
        } else if (row.ticketsState == 2) {
          this.$refs.repairOrdersForm.init(row, this.$t('审核'))
        } else if (row.ticketsState == 3) {
          let httpurl = this.url.pass
          let params = {
            dataId: record.id,
            values: {
              dataId: record.id,
            },
            comment: '',
          }
          postAction(httpurl, params).then(res => {
            if (res.success) {
              that.$message.success(this.$t('操作成功'))
            } else {
              that.$message.warning(res.message)
            }
          })
        }
      })
    },
    // 转办
    handleTransfer(row) {
      this.title = this.$t('选择转办人员')
      this.visible = true
      this.clickRow = row
      this.model = {}
    },
    // 委派
    handleDelegate(row) {
      this.title = this.$t('选择委派人员')
      this.visible = true
      this.clickRow = row
      this.model = {}
    },
    handleOk() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.confirmLoading = true
          var params = {
            dataId: this.clickRow.id,
            assignee: this.model.assignee,
            comment: this.model.remark,
          }
          if (this.title == this.$t('选择转办人员')) {
            postAction(this.url.assign, params)
              .then(res => {
                if (res.success) {
                  this.$message.success(this.$t('转办成功'))
                  this.handleCancel()
                  this.loadData()
                }
              })
              .finally(() => {
                this.confirmLoading = false
              })
          } else {
            postAction(this.url.delegate, params)
              .then(res => {
                if (res.success) {
                  this.$message.success(this.$t('委派成功'))
                  this.handleCancel()
                  this.loadData()
                }
              })
              .finally(() => {
                this.confirmLoading = false
              })
          }
        } else {
          this.$message.warning(this.$t('存在必填内容未填！'))
        }
      })
    },
    handleCancel() {
      this.visible = false
    },
    // 弹窗确认操作
    showTakeOrderModal(record, type) {
      this.$refs.takeOrderModal.showModal(record, this.url, type)
    },
    handleOrder(row) {
      this.loading = true
      let params = {
        dataId: row.id,
        values: {
          dataId: row.id,
        },
        comment: '',
      }
      postAction(this.url.pass, params).then(res => {
        if (res.success) {
          this.$message.success(this.$t('接单成功'))
          this.loadData()
        } else {
          this.$message.error(res.message)
        }
        this.loading = false
      })
    },
    checkRowStatus(record) {
      if (record.ticketsType == 0) {
        // 换表
        if (record.ticketsState == 1) {
          // 处理
          this.handleWorkOrder(record)
        } else if (record.ticketsState == 2) {
          // 审核
          this.handleNewAudit(record)
        } else if (record.ticketsState == 3) {
          // 归档
          this.showTakeOrderModal(record, '归档')
        }
      } else if (record.ticketsType == 1) {
        this.handleRepair(record)
      } else if (record.ticketsType == 2 || record.ticketsType == 11) {
        // 报修
        if (record.ticketsState == 1) {
          // 处理
          this.handleRepair(record)
        } else if (record.ticketsState == 2) {
          // 审核
          this.handleRepair(record)
        } else if (record.ticketsState == 3) {
          // 归档
          this.showTakeOrderModal(record, '归档')
        }
      } else if (
        record.ticketsType == 3 ||
        record.ticketsType == 4 ||
        record.ticketsType == 7 ||
        record.ticketsType == 8
      ) {
        // 复接 报停 销户
        this.handleTearDownAndInstall(record)
      }
    },
  },
}
</script>
<style lang="less" scoped>
@import '~@assets/less/common.less';
.myLink ::v-deep a {
  color: #5d5c5c;
}
</style>
